import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await api.requestPasswordReset(email.trim());
    } catch {
      /* server always returns 204; ignore */
    }
    setBusy(false);
    setDone(true);
  }

  if (done) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <h1>Check your email</h1>
          <div className="sub">Revenue Estimator</div>
          <p className="auth-text">
            If an account exists for <strong>{email.trim()}</strong>, a
            password-reset link is on its way. It expires in 1 hour.
          </p>
          <div className="foot-link">
            <Link to="/login">Back to sign in</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Forgot password</h1>
        <div className="sub">Revenue Estimator</div>
        <p className="auth-text muted">
          Enter the email on your account. We'll send a link to choose a
          new password.
        </p>
        <form className="auth-form" onSubmit={onSubmit}>
          <div className="field">
            <label>Email</label>
            <input
              className="input"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button className="btn" type="submit" disabled={busy}>
            {busy ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
        <div className="foot-link">
          <Link to="/login">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
